import React from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import PropTypes from "prop-types";

export default function CashTools(props) {
    return (
        <div className=" flex justify-content-around h-auto ml-1 g-1 flex-shrink-1 ">
            <Button icon="pi pi-print" className="mr-1" onClick={()=>props.setAction("PRINT")}  />
        </div>
    )
}
CashTools.propTypes = {

    setAction : PropTypes.func.isRequired,
    enable : PropTypes.bool.isRequired,
    selectedRow : PropTypes.number.isRequired,
}
{/*<Toolbar start={startContent}   />*/}